    <template>
    <vx-card>
        <div class="flex mb-4">
            <router-link to="/zxcare">
                <feather-icon icon="ChevronLeftIcon" svgClasses="text-primary mr-4"></feather-icon>
            </router-link>
            <strong class="text-primary"><small>Jenis {{ $route.query.t ? capitalize($route.query.t) : 'ZIS' }}</small></strong>
        </div>

        <div class="mb-6" v-if="!$route.query.mt">
            <strong class="block mb-4">
                <small>Pilih Lembaga Penyaluran</small>
            </strong>
            <v-select 
                v-model="mt"
                class="w-full"
                :options="mitra"
            />
        </div>

        <div class="mb-6">
            <!-- <strong class="block mb-4">
                <small>Nominal</small>
                <small class="ml-2" v-if="minTransaction > 0">Minimal Transaksi: <strong class="text-danger">{{ formatRupiah(minTransaction) }}</strong></small>
            </strong> -->
            <div class="relative">
                <small class="absolute rounded block bg-grey h-full py-2" style="z-index:99;top:0;left:0;"><strong class="block px-2">Rp.</strong></small>
                <vs-input class="rounded w-full pl-8" v-model="nominal" />
            </div>
        </div>
        
        <div class="mb-6">
            <strong class="block mb-4"><small>Apakah Infaq anda akan disalurkan kepada orang/kelompok tertentu?</small></strong>
            <div class="relative">
                <v-select 
                    v-model="typeFund" 
                    :options="typesFund" />
            </div>
        </div>
        <div class="mb-6" v-if="showDescription">
            <strong class="block mb-4">Ketarangan</strong>
            <vs-textarea v-model="description" class="w-full" />
        </div>
        <vs-button
            class="w-full"
            color="primary"
            :disabled="nominal < 1 ? true : false"
            @click.prevent="payZakat"
        >
            <strong class="rounded text-white">Lanjutkan Pembayaran</strong>
        </vs-button>
    </vx-card>
</template>
<script>
import { Validator } from 'vee-validate'
import vSelect from 'vue-select'
import { typesFund as rawTypesFund } from '@/assets/utils/zakat.js'
import { mapState } from 'vuex'
import { minTransaction } from '@/assets/utils/transaction'

const dict = {
  custom: {
    typeFund: {
      required: 'Harap pilih jenis dana'
    },
    subTypeFund: {
      required: 'Harap pilih produk jenis dana'	
    }
  }
}

Validator.localize('en', dict)

const infaqKhusus = 'infaq_khusus'

export default {
    props: ['category', 'mitra'],
    computed: {
        ...mapState('auth', ['profile'])
    },
    methods: {
        getSubCategory() {
            this.$vs.loading()
            this.$store.dispatch('getZisSubCategory', {
                kat_id: this.$route.query.ft
            })
            .then(subCategory => {
                this.$vs.loading.close()
                subCategory.map(item => {
                    item.label = item.name
                })
                this.typesFund = subCategory
            })
            .catch(e => {
                this.$vs.loading.close()
                this.showError(e)

                return false
            })
        },
        doFormat () {
            this.nominal = this.formatRupiah(this.nominal)
        },
        payZakat () {
            if(!this.$route.query.mt) {
                if(this.mt === null) {
                    this.$vs.notify({
                        title: 'Harap pilih lembaga penyaluran',
                        text: '',
                        color: 'warning',
                        position: 'top-right'
                    })

                    return false
                }
            }
            

            if(this.typeFund === null)  {
                this.$vs.notify({
                    title: 'Harap pilih kategori penyaluran infaq (khusus/tidak)',
                    text: '',
                    color: 'warning',
                    position: 'top-right'
                })

                return false
            }

            this.$validator.validateAll().then(res => {
            if (res) {
                            
                const num = parseInt(this.nominal.toString().replace(/[^0-9-,]/g, ''))

                if( num < minTransaction ) {
                    this.$vs.notify({
                        title: `Minimal Nilai Infaq Rp ${this.formatRupiah(minTransaction)}`,
                        text: '',
                        color: 'warning',
                        position: 'top-right'
                    })

                    return false
                }

                let payload = {}
                if( this.$route.query.mt ) {
                    payload = {
                        id: this.typeFund.id,
                        name: this.typeFund.label,
                        jumlah_bayar: num,
                        description: this.description,
                        mt: this.$route.query.mt
                    } 
                }
                else {
                    payload = {
                        id: this.typeFund.id,
                        name: this.typeFund.label,
                        jumlah_bayar: num,
                        description: this.description,
                        mt: this.mt.user.id
                    }
                }

                this.$vs.loading()
                this.$store.dispatch(`${this.type}/setTransactionProduct`, payload)
                .then(() => {
                    this.$vs.loading.close()
                    let nextLink = `/bayar-zis/choose-payment?ft=${this.$route.query.ft}&amount=${num}&t=${this.type}`;
                    nextLink += this.$route.query.mt ? `&mt=${this.$route.query.mt}` : `&mt=${this.mt.user.id}`;
                    nextLink += this.$route.query.ref ? `&ref=${this.$route.query.ref}` : '';

                    this.$router.push(nextLink);
                })
                .catch(e => {
                    this.$vs.loading.close()
                    console.error(e)
                    if (e.response) console.error(e.response)
                    this.$vs.notify({
                    title: 'Oops',
                    text: e.response.data.message,
                    color: 'warning',
                    position: 'top-right'
                    })
                    return false
                })
            }
            })
        }
    },
    components: {
        vSelect
    },
    watch: {
        nominal (val) {
            if (parseInt(val) || parseFloat(val)) {
            this.nominal = this.formatRupiah(this.nominal)
            }
        },
        typeFund (val) {
            if (val !== null) {
                // Update subTypesFund
                const key = val.label.split(' ').map(it => it.toLowerCase()).join('_')
                if(key === infaqKhusus) {
                    this.showDescription = true
                }
                else {
                    this.showDescription = false
                }

                this.minTransaction = parseInt(val.nominal)
            }
            else {
                this.showDescription = false
            }
        }
    },
    data: () => ({
        mt: null,
        minTransaction: 0,
        showDescription: false,
        description: null,
        type: null,
        numDay: null,
        nominal: 0,
        phone: null,
        name: null,
        email: null,
        typesFund: [],
        typeFund: null,
        subTypeFund: null,
        subTypesFund: [],
        showNumDay: false,
        greet: {id: 'bapak', label: 'Bapak'},
        greetOptions: [
            {
            id: 'bapak',
            label: 'Bapak'
            },
            {
            id: 'ibu',
            label: 'Ibu'
            }
        ]
    }),
    created () {

        if (this.profile) {
            this.name = this.profile.name
            this.email = this.profile.email
            this.phone = this.profile.no_telp
        }

        if (this.$route.query.amount) {
            this.nominal = this.formatRupiah(this.$route.query.amount)
        }

        const type = this.$route.query.t ? this.$route.query.t : 'zakat'
        this.type = type

        this.getSubCategory()

        // this.$store.dispatch(`${type}/getProduct`, type)
        //     .then(products => {
        //     products.forEach(item => {
        //         item.label = item.name
        //     })
        //     this.typesFund = products
        //     })
        //     .catch(e => {
        //     console.error(e)
        //     return false
        //     })
    }
}
</script>